import { logger } from '@/lib/logger';

/**
 * Sanitize error messages to prevent leaking internal details to users.
 * Full errors are logged to the console for debugging.
 */
export function sanitizeErrorMessage(error: unknown): string {
  logger.error('Operation failed:', error);

  if (error && typeof error === 'object') {
    const err = error as Record<string, unknown>;

    // Map common PostgreSQL error codes
    const code = err.code as string | undefined;
    if (code === '23505') return 'Ett dokument med detta namn finns redan.';
    if (code === '23503') return 'Åtgärden kunde inte slutföras på grund av beroenden.';
    if (code === '42501') return 'Du har inte behörighet för denna åtgärd.';
    if (code === 'PGRST301' || code === '401') return 'Din session har gått ut. Ladda om sidan.';

    const msg = typeof err.message === 'string' ? err.message : '';
    if (msg.includes('JWT')) return 'Din session har gått ut. Ladda om sidan.';
    if (msg.includes('Authentication required'))
      return 'Inloggning krävs för att spara till databasen. Kontrollera att autentisering är konfigurerad.';
    if (msg.includes('Database not available'))
      return 'Ingen databasanslutning tillgänglig. Sparar lokalt istället.';
    if (msg.includes('Failed to fetch') || msg.includes('NetworkError'))
      return 'Nätverksfel – kontrollera din anslutning och försök igen.';
  }

  return 'Ett tekniskt fel uppstod. Försök igen senare.';
}
